import React, { useState, useEffect } from "react";
import { Database, HardDrive, Layers, PieChart as PieChartIcon, TrendingUp } from "lucide-react";
// import { getAsperoStorageStats } from "@/services/api/aspero";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

const COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"];

/**
 * Storage statistics visualization component
 * Displays database size, document count, and age distribution
 */
const StorageStats = ({ autoRefresh = true, refreshInterval = 60000 }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
      <div className="flex items-center text-gray-600">
        <Database className="h-5 w-5 mr-2" />
        <span className="text-sm font-medium">Storage statistics are currently disabled.</span>
      </div>
    </div>
  );
};

export default StorageStats;
